module.exports = new __parcel__URL__("atlassian-icon.1175e11b.svg").toString();